import { useContext } from 'react';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { DepositContext } from '@web3/base-provider-v2';

export const useDeposit = () => {
  return useContext(DepositContext);
};
